var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.data)?_c('v-container',{attrs:{"fluid":""}},[_c('QueryLogDetailsHeader',{attrs:{"item":_vm.data}}),_c('QueryLogDetailsTable',{attrs:{"item":_vm.data}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }